import { Employee } from '../../user/models/index';
import { CostCode } from '../../user.project/components/costcodes/models/costcode';

export class TimeCardEmployee {
  Employee: Employee;
  CostCodes: CostCode[] = [];
  TimeDescriptionId: string;
  TotalHours: number;
}
